import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ForumHeader from './ForumHeader'
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { useQuery } from '@apollo/react-hooks'
import { useParams } from 'react-router-dom'
import { forumQueries } from '../../graphql/queries'
import TopicCard from '../../components/Forum/TopicCard'
import LoadMoreButton from '../../components/Forum/LoadMoreButton'
import TopicFormDialog from './TopicFormDialog'
import FilterDialog from './FilterDialog'
import FilterListIcon from '@material-ui/icons/FilterList'
import PostAddIcon from '@material-ui/icons/PostAdd'
import useQueryString from '../../hooks/useQueryString'
import EmptyPlaceholder from '../../components/Forum/EmptyPlaceholder'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflowY: 'scroll'
  },
  listHeader: {
    display: 'flex',
    marginTop: 48,
    paddingTop: 24,
    paddingBottom: 24,
    flexWrap: 'wrap'
  },
  formControl: {
    width: '30%',
    marginRight: 36,
    marginBottom: 0,
    '@media only screen and (max-width: 1050px)': {
      width: '100%',
      marginTop: 10
    },
    '& fieldset': {
      border: 'none'
    },
    '& div': {
      background: '#fff'
    }
  },
  filters: {
    flex: 1,
    '@media only screen and (max-width: 1050px)': {
      flex: 'none',
      width: '100%'
    }
  },
  newButton: {
    width: 'auto',
    '@media only screen and (max-width: 1050px)': {
      marginTop: 10,
      height: '3.3em',
      width: '100%'
    }
  },
  filterButton: {
    width: 'auto',
    height: '100%',
    '@media only screen and (max-width: 1050px)': {
      marginTop: 10,
      height: '3.3em',
      width: '100%'
    }
  }
}))

const Profile = () => {
  const classes = useStyles()
  const { cursoId: courseId } = useParams()
  const [cursoId, setCursoId] = useState(null)
  const [category, setCategory] = useQueryString('categoria', 'all')
  const [sort, setSort] = useQueryString('sort', 'desc')
  const [fetchingMoreTopics, setFethingMoreTopics] = useState(false)

  const { data: dataCategoriasForum } = useQuery(forumQueries.GET_FORUM_CATEGORIES, { variables: { curso_id: courseId } })

  const {
    loading: loadingTopicosForum,
    data: dataTopicosForum,
    fetchMore: fetchMoreTopics,
    refetch: refetchTopicosForum
  } = useQuery(forumQueries.GET_FORUM_TOPICS, { variables: { curso_id: cursoId ? cursoId : courseId, categoria_id: category, sort } })

  const handleChangeSort = e => {
    setSort(e.target.value)
  }

  const [newModalIsOpen, setNewModalIsOpen] = React.useState(false)
  const [filterModal, setFilterModal] = React.useState(false)

  const openNewTopicModal = () => {
    setNewModalIsOpen(true)
  }

  const handleCloseFilter = () => {
    setFilterModal(false)
  }

  const openFilterModal = () => {
    setFilterModal(true)
  }

  const handleClose = () => {
    setNewModalIsOpen(false)
  }

  const handleLoadMore = () => {
    setFethingMoreTopics(true)
    fetchMoreTopics({
      variables: { page: ((dataTopicosForum || {}).topicosForum || {}).page + 1 },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        setFethingMoreTopics(false)
        return Object.assign({}, prev, {
          topicosForum: {
            ...prev.topicosForum,
            page: fetchMoreResult.topicosForum.page,
            edges: [...prev.topicosForum.edges, ...fetchMoreResult.topicosForum.edges]
          }
        })
      }
    })
  }

  const handleCreateNewTopic = () => {
    refetchTopicosForum()
  }

  const edges = ((dataTopicosForum || {}).topicosForum || []).edges

  return (
    <div className={classes.root}>
      <Container>
        <ForumHeader />
      </Container>
      <Container className={classes.listHeader}>
        <div className={classes.filters}>
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={sort}
              onChange={handleChangeSort}
              label="Categoria"
              native
            >
              <option value={'desc'}>Ordenar por mais recentes</option>
              <option value={'pop'}>Ordenar por mais populares</option>
            </Select>
          </FormControl>
          <Button className={classes.filterButton} variant="contained" onClick={openFilterModal} color="primary">
            <FilterListIcon style={{ marginRight: 10 }} /> Filtrar Tópicos
          </Button>
        </div>
        <Button className={classes.newButton} variant="contained" onClick={openNewTopicModal} color="primary">
          <PostAddIcon style={{ marginRight: 10 }} /> Novo Tópico
        </Button>
      </Container>
      <Container>
        {loadingTopicosForum
          ? [1, 2].map(i => {
              return <TopicCard loading={true} />
            })
          : edges !== undefined &&
            (edges || []).map(topic => {
              return (
                <TopicCard
                  _id={(topic || {})._id}
                  to={`/forum/${courseId}/${topic._id}`}
                  postadoPor={topic.postadoPor}
                  category={(topic.categoria || {}).label}
                  title={topic.titulo}
                  description={topic.descricao}
                  curso_id={courseId}
                  visualizacoes={(topic || {}).visualizacoes}
                  createdAt={topic.createdAt}
                  quantidadeRespostas={topic.quantidadeRespostas}
                />
              )
            })}

        {!!fetchingMoreTopics &&
          [1, 2].map(i => {
            return <TopicCard loading={true} />
          })}
        {edges && !(((dataTopicosForum || {}).topicosForum || {}).page >= (((dataTopicosForum || {}).topicosForum || {}).pagesAmount || 0)) && (
          <LoadMoreButton onClick={handleLoadMore} loading={loadingTopicosForum || fetchingMoreTopics} />
        )}
        {!(edges || []).length && !loadingTopicosForum && <EmptyPlaceholder />}
      </Container>
      <TopicFormDialog
        query={{
          query: forumQueries.GET_FORUM_TOPICS,
          variables: { curso_id: courseId, categoria_id: category, sort }
        }}
        category={category}
        cursoId={cursoId ? cursoId : courseId}
        onCompleted={handleCreateNewTopic}
        open={newModalIsOpen}
        handleClose={handleClose}
      ></TopicFormDialog>

      <FilterDialog
        setCursoId={curso => setCursoId(curso)}
        category={category}
        cursoId={cursoId ? cursoId : courseId}
        setNewCat={cat => setCategory(cat)}
        optionsCategories={(dataCategoriasForum || {}).categoriasForum}
        open={filterModal}
        handleClose={handleCloseFilter}
      ></FilterDialog>
    </div>
  )
}

export default Profile
